import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted, useSlots, onBeforeMount, provide, reactive, watch, Slot, computed} from 'vue'

type Props = {
    modelValue?: number
}
type Emits = {
    (o: 'update:modelValue', modelValue: number): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'tabs',
  props: {
    modelValue: { default: 0 }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose, emit }: { emit: ({
    (o: 'update:modelValue', modelValue: number): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as { modelValue: number }





const activeIdx = ref(0);
const state = reactive({
    selectedTab: ''
});

provide('selectedTab', state)

const slots = useSlots();
const defaultSlot = computed(() => slots.default ? slots.default() : []);

onMounted(() => {
    updateIndex(props.modelValue);
})

watch(()=>props.modelValue, (newVal,oldVal)=>{
    updateIndex(newVal)
});

function updateIndex(idx: number){
    if(idx && idx >= 0 && idx < defaultSlot.value.length){
        activeIdx.value = idx;
        state.selectedTab = defaultSlot.value[idx].props!.title;
    }else{
        activeIdx.value = 0;
        state.selectedTab = defaultSlot.value[0].props!.title;
    }
    emit('update:modelValue', activeIdx.value)
}


const __returned__ = { props, emit, activeIdx, state, slots, defaultSlot, updateIndex, ref, onMounted, useSlots, onBeforeMount, provide, reactive, watch, Slot, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})